export default __webpack_public_path__ + "997cfbd5f788fbbd5d561bc5e9e7ffd9.svg";